<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="m10 16 2.94-2.94a1.5 1.5 0 0 0 0-2.12L10 8"
      stroke="currentColor"
    stroke-linecap="round"
    stroke-linejoin="round"
    stroke-width="2"
    />
  </svg>
</template>

<script lang="ts" setup>
import type { IconProps } from '../types.js'

withDefaults(
  defineProps<IconProps>(),
  {
    size: 20,
  }
)
</script>
